import { createFromBaseTheme } from "@/style/baseTheme"; 
import { createTheme, ThemeOptions } from "@mui/material";

import logo from '/images/logo.png'
import logoBar from '/images/logoBar.png'

const customConstants: ThemeOptions =  {
  palette: {
    primary: {
      main: "#c3d100",
    },
    secondary: {
      main: "#c0c0c0",
    }
  },
  custom: {
    constants: {
      logoImage: logo,
      logoBarImage: logoBar,
    }
  }
}; 
const baseCustomizedTheme = createFromBaseTheme(customConstants); 
const customizations: ThemeOptions = {} 
const newTheme = createTheme(baseCustomizedTheme, customizations); 

export default newTheme;
